import React, { useState } from 'react';
    import { motion, AnimatePresence } from 'framer-motion';
    import { useVideo } from '../../context/VideoContext';
    import CompanyForm from './CompanyForm';
    import SafeIcon from '../../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiPlus, FiEdit2, FiTrash2, FiStar, FiMapPin, FiBriefcase } = FiIcons;

    const CompanyManagement = () => {
      const [showForm, setShowForm] = useState(false);
      const [editingCompany, setEditingCompany] = useState(null);
      const { companies, deleteCompany } = useVideo();

      const handleEdit = (company) => {
        setEditingCompany(company);
        setShowForm(true);
      };

      const handleClose = () => {
        setShowForm(false);
        setEditingCompany(null);
      };

      return (
        <div className="space-y-6">
          <div className="glass-card p-6">
            <div className="flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-white mb-2">Production Directory</h2>
                <p className="text-white/80">Manage production house profiles and ratings</p>
              </div>
              <button onClick={() => setShowForm(true)} className="btn-primary flex items-center gap-2">
                <SafeIcon icon={FiPlus} /> Add Company
              </button>
            </div>
          </div>

          <AnimatePresence mode="wait">
            {showForm ? (
              <CompanyForm company={editingCompany} onClose={handleClose} />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {companies.map((company, idx) => (
                  <motion.div 
                    key={company.id}
                    className="glass-card p-6 border-white/5 group relative overflow-hidden"
                    layout
                  >
                    <div className="absolute top-0 left-0 px-3 py-1 bg-orange-500 text-white font-black text-[10px] rounded-br-xl shadow-lg z-10">
                      #{idx + 1}
                    </div>
                    <div className="flex gap-6 mt-2">
                      <div className="w-20 h-20 rounded-2xl bg-zinc-800 overflow-hidden flex-shrink-0 border border-white/5">
                        {company.logo_url ? (
                          <img src={company.logo_url} className="w-full h-full object-cover" alt={company.name} />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-white/10 italic text-xs">No Logo</div>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="text-xl font-bold text-white truncate">{company.name}</h4>
                          <div className="flex gap-2">
                            <button onClick={() => handleEdit(company)} className="p-2 bg-white/5 hover:bg-blue-500/20 text-blue-400 rounded-xl transition-all"><FiEdit2 /></button>
                            <button onClick={() => deleteCompany(company.id)} className="p-2 bg-white/5 hover:bg-red-500/20 text-red-400 rounded-xl transition-all"><FiTrash2 /></button>
                          </div>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-slate-400 mb-4">
                          <span className="flex items-center gap-1"><FiStar className="text-amber-400" /> {company.overall_rating}</span>
                          <span className="flex items-center gap-1"><FiMapPin /> {company.location}</span>
                          <span className="flex items-center gap-1"><FiBriefcase /> {company.portfolio_size} SaaS Projects</span>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <span className="px-3 py-1 bg-orange-500/10 text-orange-500 text-[10px] font-black uppercase rounded-full border border-orange-500/20">{company.speciality}</span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </AnimatePresence>
        </div>
      );
    };

    export default CompanyManagement;